/**
 * MeterReadingsComponent created by karora on 28/03/17.
 */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { AppComponent } from '../app.component';
import { HubService } from '../services/hub.service';
import { HubAction } from '../types/hub-action';

@Component({
  selector: 'hub-actions',
  template: `<hub-sub-menu></hub-sub-menu>
  <ul class="actions">
    <li>
      <span (click)="later()" class="created center">Newer</span>
      <span class="hubid" *ngIf="!this.hubID">HubID</span>
      <span class="type">Type</span>
      <span class="action">Action</span>
      <span class="initiator">Initiator</span>
      <span class="userid">User</span>
      <span class="state">State</span>
      <span class="setting">Setting</span>
    </li>
  
    <li *ngFor="let action of actions">
      <span class="created"> {{action.created | godate}} </span>
      <span class="hubid" *ngIf="!this.hubID"> {{action.hubid}} </span>
      <span class="type"> {{action.type}} </span>
      <span class="action"> {{action.action}} </span>
      <span class="initiator"> {{action.initiatorid}} </span>
      <span class="userid"> {{action.userid}} </span>
      <span class="state"> {{action.setstate}} </span>
      <span class="setting"> {{action.setting}} </span>
    </li>
  
    <li>
      <span (click)="earlier()" class="created center">Older</span>
    </li>
  </ul>
  `,
  styles: [
    `.actions { margin: 0 0 2em 0; list-style-type: none; padding: 0; }`,
    `.actions li { position: relative; left: 0; margin: 0.1em 0; padding: 0; height: inherit; background-color: #DDD; }`,
    `.actions li span { display: inline-block; position: relative; top: 0; left: 0; padding: 0.2em 0.5em; margin: 0.1em;}`,
    `.actions li:hover { color: #607D8B; background-color: #DDD; }`,
    `.created { width: 10em; color: white; background-color: #607D8B; padding: 0.63em; }`,
    `.type { width: 8em; }`,
    `.action { width: 6em; }`,
    `.initiator { width: 4em; text-align: right; }`,
    `.userid { width: 4em; text-align: right; }`,
    `.hubid { width: 4em; text-align: right; }`,
    `.state { width: 5em;  text-align: center;}`,
    `.setting { width: 15em; }`,
  ],
  providers: [HubService],
})


export class HubActionsComponent implements OnInit {
  actions: HubAction[];
  hubID: number;
  private fromTimestamps: Date[];
  errorMessage: string;

  static handleRefreshError(err: any): void {
    if (err.status !== 401) {
      console.log('MeterReadings Error: ' + err);
    }
  }

  constructor(
    private hubService: HubService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    this.route.params.pipe(
      switchMap((params: Params) => this.switchedHub(+params['hubid']))
    ).subscribe();
  }

  switchedHub(hubID: number): Observable<boolean> {
    console.log('Switched HUB: ' + hubID);
    this.hubID = hubID;
    this.fromTimestamps = <Date[]>{};
    this.later();
    return of(true);
  }

  gotActions(actions: HubAction[]): void {
    let updated = <HubAction[]>[];
    for (let r of actions) {
      updated.push(r);
    }
    this.actions = updated;
  }

  earlier(): void {
    let created: Date = null;
    try {
      created = this.actions[this.actions.length - 1].created;
      if (!this.fromTimestamps) {
        this.fromTimestamps = <Date[]>[];
      }
      this.fromTimestamps.push(this.actions[0].created);
    } catch (err) {
      console.log(err);
    }
    this.refresh(created);
  }

  later(): void {
    let created: Date = null;
    if (this.fromTimestamps) {
      try {
        created = this.fromTimestamps[this.fromTimestamps.length - 1];
        this.fromTimestamps = this.fromTimestamps.slice(0, -1);
      } catch (err) { }
    }
    this.refresh(created);
  }

  refresh(created: Date): void {
    this.hubService.getHubActions(+this.hubID, created)
      .subscribe(
        values => this.gotActions(values),
        err => HubActionsComponent.handleRefreshError(err)
      );
  }

}

